import moment from "moment-timezone";
import {EVENT_DATE_FORMAT, type IScheduledEvent} from "~/data/events";

export function isDone(event: IScheduledEvent) {
    const now = moment();
    const $momentDate = moment(event.dateEnd, EVENT_DATE_FORMAT);
    return now.isAfter($momentDate);
}